import { render } from "./VoucherList.vue?vue&type=template&id=86230936&scoped=true"
import script from "./VoucherList.vue?vue&type=script&lang=js"
export * from "./VoucherList.vue?vue&type=script&lang=js"

import "./VoucherList.vue?vue&type=style&index=0&id=86230936&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86230936"]])

export default __exports__